import Checkbox from "../../../components/checkbox/checkbox";
import PillTitle from "../../../components/pillTitle/pillTitle";
import type { ParametersPanelModel } from "../../../type/parameters";
import { useI18n } from "../../../utils/translate/i18n/useI18n";
import "../userSettings.scss";
import "./parametersPanel.scss";



export default function ParametersPanel({ parameters, onParamChange, isAdmin }: ParametersPanelModel) {
  const { t } = useI18n();
  const paramEntries = Object.entries(parameters).filter(
    ([, entry]) => !entry.forAdminVisible || isAdmin
  );

  return (
    <div className="app-content__panelleft__container p-4">
      <div>
        <PillTitle variant="blue-brighter" text={t("Parametry")} />
      </div>

      {paramEntries.length === 0 && (
        <p className="parameters-panel__empty">{t("Brak skonfigurowanych parametrów.")}</p>
      )}

      {paramEntries.map(([key, entry]) => (
        <div key={key} className="panel--parameters--checkboxplace mb-3">
          {entry.paramtype === "bool" || entry.paramtype === "boolean" ? (
            <Checkbox
              label={entry.label || key}
              description={entry.description || ""}
              checked={entry.value === true}
              onChange={() => onParamChange(key, entry.value !== true)}
              variant="compact"
            />
          ) : (
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <span className="parameters-panel__param-label">{entry.label || key}</span>
                {entry.description && (
                  <p className="parameters-panel__param-desc mb-0">{entry.description}</p>
                )}
              </div>

              {entry.paramtype === "number" ? (
                <input
                  type="number"
                  className="form-control user-settings__input user-settings__input--narrow ms-3"
                  value={entry.value as number}
                  onChange={(e) => onParamChange(key, Number(e.target.value))}
                />
              ) : (
                <input
                  type="text"
                  className="form-control user-settings__input user-settings__input--narrow ms-3"
                  value={entry.value as string}
                  onChange={(e) => onParamChange(key, e.target.value)}
                />
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
